/**
 * @description Shared clear-then-announce pattern for ARIA live regions.
 */
export class LiveRegionUtilities {

	static clear( region: HTMLElement | null | undefined ): void {
		if ( region ) {
			region.textContent = '';
		}
	}

	static announce( region: HTMLElement | null | undefined, message: string | null | undefined ): void {
		if ( !region ) {
			return;
		}
		if ( !message ) {
			LiveRegionUtilities.clear( region );
			return;
		}

		const msg = String( message ).trim();
		if ( !msg.length ) {
			return;
		}

		region.textContent = '';
		window.setTimeout( () => {
			region.textContent = msg;
		}, 0 );
	}
}